export enum GiveawayQuestionTypeUi {
  CHOICE = 'CHOICE',
  TEXT = 'TEXT',
  PARAGRAPH = 'PARAGRAPH',
}
